<template>
    <div>
        <el-popover placement="bottom" width="50" trigger="hover">
            <div class="cs-homework-action-buttonlist" v-if="data.CanEdit">
                <el-row>
                    <el-button size="mini" @click="editHomework()">编辑</el-button>
                </el-row>
                <br>
                <el-row>
                    <el-button size="mini" @click="deleteHomework()">删除</el-button>
                </el-row>
            </div>
            <span slot="reference" style="border" class="cs-homework-action"> {{actions}} </span>
        </el-popover>
    </div>
</template>

<style lang="scss" scoped>
.cs-homework-action{
    cursor: pointer;
}
.cs-homework-action-buttonlist{
    text-align: center; 
    margin:0
}
</style>

<script>
export default {
    props: {
        data: {},
    },
    data() {
        return {
            actions: '',
        };
    },
    components: {},
    created() {
        this.init();
    },
    methods: {
        init() {
            if (!!this.data) {
                if (this.data.CanEdit){
                    this.actions = this.data.Actions;
                }else{
                    this.actions = "";
                }
            }
        },
        editHomework() {
            let data = {
                action: "editHomework",
                data: this.data,
            };
            this.$emit("customEvent", data);
        },
        deleteHomework() {
          let data = {
                action: "deleteHomework",
                data: this.data,
            };
            this.$emit("customEvent", data);
        }
    },
    watch: {
        data: function() {
            this.init();
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/common/paginationCells/homeworkActionsCell.vue